import { render, staticRenderFns } from "./joinList.vue?vue&type=template&id=52104a31&scoped=true"
import script from "./joinList.vue?vue&type=script&lang=js"
export * from "./joinList.vue?vue&type=script&lang=js"
import style0 from "./joinList.vue?vue&type=style&index=0&id=52104a31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52104a31",
  null
  
)

export default component.exports